<template>
	<div class="social-share">
		<p class="message" v-html="ui.share_message"></p>
		<ul class="social-links no-list">
			<li class="social-item facebook">
				<a :href="facebookShareURL" target="_blank" class="social-link facebook-icon"
				@click="share('Facebook')">
					<img class="icon" src="@assets/img/icon-facebook.svg" />
				</a>
			</li>
			<li class="social-item twitter">
				<a :href="twitterShareURL" target="_blank" class="social-link twitter-icon"
				@click="share('Twitter')">
					<img class="icon" src="@assets/img/icon-twitter.svg" />
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
	computed: {
		...mapState({
			ui: state => state.config.info.post_game,
			completedGameCycles: state => state.cycle.completedGameCycles,
		}),
		encodedUrl() {
			return encodeURIComponent(window.location.hostname);
		},
		facebookShareURL() {
			return `https://www.facebook.com/sharer/sharer.php?u=${this.encodedUrl}`;
		},
		twitterShareURL() {
			return `https://twitter.com/share?url=${this.encodedUrl}&text=${encodeURIComponent(this.twitterText)}`;
		},
		twitterText() {
			return this.ui.twitter_prepopulated_share_text.replace("{{ completedGameCycles }}", this.completedGameCycles);
		},
	},
	methods: {
		...mapActions([
			"sendEvent",
		]),
		share(network) {
			this.sendEvent({
				ec: "Post-Game",
				ea:	"Share",
				el: network,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
	.social-share {
		color: $brand-color-alt-darker;
		font-size: 24px;
		font-weight: 600;

		@include mobile {
			font-size: 20px;
			font-weight: 600;
		}
	}

	.social-links {
		display: flex;
		justify-content: center;
		margin-bottom: 4vh;
	}

	.social-item {
		&:not(:first-child) {
			margin-left: .5em;
		}
	}

	.social-link {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 2em;
		height: 2em;
		border-radius: 50%;
		background-color: $brand-color-alt-darker;
		transition: all $ui-transition-duration;

		&:hover {
			text-decoration: none;
			background-color: rgba(255, 255, 255, .75);
		}
	}

	.icon {
		max-width: 65%;
		max-height: 65%;
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/SocialShare.vue